// extracted by mini-css-extract-plugin
export var education = "style-module--education--0a38b";
export var education__block = "style-module--education__block--e55cd";
export var education__blockText = "style-module--education__block-text--3795d";
export var education__blocks = "style-module--education__blocks--0e74a";
export var education__title = "style-module--education__title--c2f40";